import Modal from 'react-modal/lib/components/Modal';
import "./ModalQrCodePix.css";
import { QRCodeSVG } from "qrcode.react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function ModalQrCodePix(props) {

    const handleCopy = () => {
        const id = toast.loading("Copiado com sucesso !", {position : toast.POSITION.TOP_CENTER});

        toast.update(id, {
            render: "Copiado com sucesso !", 
            type: "success", 
            isLoading: false,                             
           autoClose: 2000});
    };

    return (
        <Modal 
            isOpen={props.isOpen}
            onRequestClose={props.onRequestClose}
            overlayClassName="react-modal-overlay"
            ariaHideApp={false}
            className="react-modal-content"
        >
            

            <div className="bsmodal-content">
                <div className="bsmodal-header text-center">
                    <label>Leia o QRCode para efetuar o pagamento!</label>                                                           
                </div>
                <div className="bsmodal-body">                    
                    <div className="row">
                        <div className="col mb-3">
                            <div className="d-flex w-100 mb-1 justify-content-center">
                                {props.QrCodePix && props.QrCodePix && (
                                    <QRCodeSVG height={'200px'} width={'200px'} value={props.QrCodePix} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bsmodal-footer">
                    <div>
                        <input type="text" className="form-control" value={props.QrCodePix} aria-describedby="emailHelp" disabled/>                        
                        <CopyToClipboard text={props.QrCodePix} onCopy={handleCopy}>
                            <button className="btn btn-copiacola btn-success w-100 mt-2  bi bi-copy h-100"> Copia e Cola</button>
                        </CopyToClipboard>                 
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ModalQrCodePix;
